/** The steps between opening a Bescheid and displaying its files. */
export enum BescheidLoadPhase {
  Downloading = 'downloading',
  Decrypting = 'decrypting',
  Extracting = 'extracting',
}
